<app-nav
    [titulo]="tipoFianza ? 'Editar tipo de fianza: ' + tipoFianza.nombre : 'Nuevo tipo de fianza'"
    [descripcion]="tipoFianza ? 'Aquí podrá modificar los datos del tipo de fianza.' : 'Por favor complete todos los datos del nuevo tipo de fianza.'">
    <div class="edit-tipo-fianza basic-avm-editor">
        <div class="form-stepper">
            <form [formGroup]="form" class="form-step">

                <h3 class="form-step-title">{{ tipoFianza ? 'Editar tipo de fianza' : 'Nuevo tipo de fianza' }}</h3>
                <span class="form-step-description">
                    {{ tipoFianza ? 'Modificá los datos y guardá los cambios.' : 'Completá los datos del nuevo tipo de fianza.' }}
                </span>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Nombre</mat-label>
                        <input matInput formControlName="nombre" placeholder="Ej: Alquiler / Expensa / ABL">
                        <mat-error *ngIf="form.controls['nombre'].hasError('required')">El nombre es requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Clave</mat-label>
                        <mat-select formControlName="clave">
                            <mat-option *ngFor="let op of claveOpciones" [value]="op.value">
                                {{ op.label }}
                            </mat-option>
                        </mat-select>
                        <mat-hint>Usada internamente por el motor de cálculo.</mat-hint>
                        <mat-error *ngIf="form.controls['clave'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Plazo mínimo (meses)</mat-label>
                        <input matInput formControlName="plazoMinMeses" type="number" style="text-align: right;">
                        <span matSuffix>&nbsp;meses</span>
                        <mat-error *ngIf="form.controls['plazoMinMeses'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Plazo máximo (meses)</mat-label>
                        <input matInput formControlName="plazoMaxMeses" type="number" style="text-align: right;">
                        <span matSuffix>&nbsp;meses</span>
                        <mat-error *ngIf="form.controls['plazoMaxMeses'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Coeficiente de prima mensual</mat-label>
                        <input matInput formControlName="coeficientePrimaMensual" type="number" style="text-align: right;">
                        <span matSuffix>&nbsp;% / mes</span>
                        <mat-hint>Factor mensual que se multiplica por la cantidad de meses.</mat-hint>
                        <mat-error *ngIf="form.controls['coeficientePrimaMensual'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Comisión</mat-label>
                        <input matInput formControlName="comision" type="number" style="text-align: right;">
                        <span matSuffix>&nbsp;%</span>
                        <mat-error *ngIf="form.controls['comision'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                </div>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Tipos de descuento aplicables</mat-label>
                    <mat-select formControlName="idsTipoDescuento" multiple>
                        <mat-option *ngFor="let td of tiposDescuento" [value]="td.id">
                            {{ td.nombre }}
                        </mat-option>
                    </mat-select>
                    <mat-hint>Dejar vacío si no aplican descuentos a esta fianza.</mat-hint>
                </mat-form-field>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Zona (dejar vacío para Default)</mat-label>
                    <mat-select formControlName="idZona">
                        <mat-option [value]="null">Default (todas las zonas)</mat-option>
                        <mat-option *ngFor="let zona of zonas" [value]="zona.id">
                            {{ zona.nombre }}
                        </mat-option>
                    </mat-select>
                    <mat-hint>Las configuraciones Default aplican a todas las zonas sin override específico.</mat-hint>
                </mat-form-field>

                <div class="form-radio-line">
                    <span class="radio-line-label">Tipo de producto</span>
                    <div class="radios">
                        <mat-radio-group formControlName="tipoProducto">
                            <mat-radio-button value="VIVIENDA">Vivienda</mat-radio-button>
                            <mat-radio-button value="COMERCIAL">Comercial</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-radio-line">
                    <span class="radio-line-label">Estado</span>
                    <div class="radios">
                        <mat-radio-group formControlName="activo">
                            <mat-radio-button [value]="true">Activo</mat-radio-button>
                            <mat-radio-button [value]="false">Inactivo</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-step-buttons">
                    <button mat-button type="button" class="garantor-button" (click)="cancel()">Cancelar</button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="save()">
                        {{ tipoFianza ? 'Guardar cambios' : 'Crear tipo de fianza' }}
                    </button>
                </div>

            </form>
        </div>
    </div>
</app-nav>
